import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface MissingAttachmentsWarningProps {
  isOpen: boolean;
  saveAndContinue: () => void;
  onClose: () => void;
}

const MissingAttachmentsWarning = ({ isOpen, saveAndContinue, onClose }: MissingAttachmentsWarningProps) => {
  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      confirmButton={{
        name: 'Continue',
        onClick: () => {
          saveAndContinue();
          onClose();
        }
      }}
    >
      <ModalBody>
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="57" viewBox="0 0 60 57" fill="none">
          <g clipPath="url(#clip0_20422_197175)">
            <path
              d="M49.035 57.0005H10.9843C10.9423 56.9925 10.9004 56.98 10.8574 56.9754C10.4259 56.931 9.99094 56.9128 9.56394 56.8422C7.33492 56.4698 5.3732 55.5256 3.72522 53.9711C1.67063 52.0315 0.470042 49.6353 0.0872126 46.8268C0.0532337 46.5763 0.0283158 46.3246 0 46.074C0 45.6025 0 45.131 0 44.6607C0.00906105 44.6197 0.0237853 44.5787 0.0271831 44.5365C0.0883452 43.6072 0.271831 42.7018 0.545928 41.8123C0.855137 40.8067 1.3433 39.8876 1.85072 38.9742C3.00374 36.8969 4.14996 34.815 5.29845 32.7354C6.59644 30.3848 7.89331 28.0341 9.19017 25.6835C10.3364 23.6073 11.4826 21.5322 12.6277 19.456C13.8804 17.1874 15.132 14.9176 16.3835 12.6489C17.5263 10.5773 18.6782 8.51137 19.8097 6.43291C20.4293 5.29517 21.1258 4.21778 22.0455 3.29984C23.7841 1.56418 25.8625 0.498186 28.2863 0.134882C30.2696 -0.161228 32.2098 0.0323824 34.0843 0.765824C36.627 1.76121 38.5378 3.49231 39.8743 5.87144C40.6297 7.21646 41.366 8.57287 42.1112 9.92473C43.2608 12.0089 44.4127 14.093 45.5623 16.1783C47.1005 18.9663 48.6386 21.7555 50.1767 24.5434C51.5234 26.9841 52.8701 29.4247 54.2168 31.8653C55.329 33.8812 56.4435 35.8958 57.5524 37.9139C58.0077 38.7419 58.4902 39.5585 58.8912 40.4138C59.9536 42.6779 60.248 45.057 59.7939 47.5181C59.3635 49.8483 58.3169 51.871 56.6723 53.5668C54.7208 55.5792 52.3389 56.6987 49.5549 56.9527C49.3816 56.9686 49.2083 56.9857 49.0361 57.0016L49.035 57.0005ZM30.0057 50.2742C36.2204 50.2742 42.4352 50.2742 48.6488 50.2742C49.5934 50.2742 50.4565 49.9998 51.2312 49.4543C53.2654 48.0193 53.9155 45.1869 52.7081 42.9706C51.6491 41.0265 50.5708 39.0915 49.5016 37.1532C48.1413 34.6863 46.7811 32.2195 45.4208 29.7527C44.0843 27.3292 42.7478 24.9056 41.4113 22.4821C40.3013 20.4708 39.1913 18.4595 38.0813 16.4471C37.1775 14.8083 36.2759 13.1683 35.3698 11.5317C34.8884 10.6616 34.4309 9.77667 33.9098 8.93048C33.1986 7.77224 32.1599 7.04449 30.8212 6.79166C28.8855 6.42608 26.9283 7.36565 25.9554 9.12181C24.6336 11.5089 23.3163 13.8983 21.9991 16.2877C20.4089 19.1702 18.8209 22.0538 17.2307 24.9364C15.3993 28.2562 13.5667 31.576 11.7341 34.8959C10.2684 37.5506 8.79828 40.2031 7.34171 42.8624C6.44241 44.5058 6.41296 46.18 7.32359 47.82C8.21837 49.4326 9.60584 50.2754 11.4645 50.2765C17.6453 50.2777 23.8249 50.2765 30.0057 50.2765V50.2742Z"
              fill={themeVar('font.disabled') || '#ABABAB'}
            />
            <path
              d="M33.3326 24.3233C33.3326 26.8015 33.3337 29.2809 33.3326 31.7591C33.3326 32.9435 32.8705 33.9048 31.9066 34.5938C31.1749 35.1165 30.3526 35.3101 29.4635 35.1541C28.272 34.9468 27.4338 34.2703 26.9332 33.1713C26.7418 32.7511 26.6614 32.3023 26.6614 31.8411C26.6614 26.8198 26.658 21.7996 26.6625 16.7782C26.6636 15.1667 27.7566 13.824 29.3174 13.4823C31.1058 13.0917 32.9226 14.2977 33.2669 16.112C33.3133 16.3557 33.3314 16.6085 33.3314 16.8579C33.336 19.3464 33.3337 21.8349 33.3337 24.3233H33.3326Z"
              fill={themeVar('font.disabled') || '#ABABAB'}
            />
            <path
              d="M29.9907 47.774C27.687 47.7705 25.8306 45.8925 25.834 43.5692C25.8363 41.2584 27.7017 39.3883 30.0009 39.3906C32.3206 39.3929 34.1871 41.3142 34.1622 43.6387C34.1384 45.905 32.2673 47.7785 29.9907 47.7751V47.774Z"
              fill={themeVar('font.disabled') || '#ABABAB'}
            />
          </g>
          <defs>
            <clipPath id="clip0_20422_197175">
              <rect width="60" height="57" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <ModalTitle>Missing Attachments</ModalTitle>
        <ModalDescription>Expected attachments are missing. Are you sure you’d like to continue?</ModalDescription>
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default MissingAttachmentsWarning;

const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
`;

const ModalTitle = styled.div`
  font-family: Blinker;
  font-size: 33px;
  font-weight: 400;
  line-height: 46.2px;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 16px;
  text-align: center;
  color: ${themeVar('font.base')};
`;
